export default (superClass) => {
    return class extends superClass {
        get carLoanType() {
            return this._data.car_loan_type || 'without_collateral';
        }

        get maxLTVRatio() {
            if (this.carLoanType === 'without_collateral') {
                return 100;
            }
            return this._data.car_loan_max_ltv_ratio || 100;
        }

        get maxLTVString() {            
            return this.formatPercentage(this.maxLTVRatio);
        }

        get downPaymentRatio() {
            return 100 - this.maxLTVRatio;
        }

        get downPaymentString() {
            return this.formatPercentage(this.downPaymentRatio);
        }

        get onlyCarDealer() {
            if (this.carLoanType === 'without_collateral') {
                return false;
            }
            return this._data.car_loan_only_car_dealer;
        }
        
        get environmentalRebatePercentage() {
            return this._data.car_loan_environmental_rebate_percentage || 0;
        }

        get hasEnvironmentalRebate() {
            return this._data.car_loan_has_environmental_rebate || false;
        }

        get environmentalRebatePercentageString() {
            if (this.hasEnvironmentalRebate) {
                return this.formatPercentage(this.environmentalRebatePercentage);
            }
            return  this.formatPercentage(0);
        }
    }
}